import { useEffect, useState } from "react";
import TableComponent from "../../components/table/TableComponent";
import { Column } from "../../interfaces/table.interface";
import { formatDateTime } from "../../utils/date&time.util";
import { get } from "../../redux/ApiHelper";
import { GroupClassPaymentInterface } from "../../interfaces/group-class.interface";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { getInfo } from "../../redux/slices/InfoSlice";
import { startLoading, stopLoading } from "../../redux/slices/WindowSlice";
import { DispatchType } from "../../interfaces/redux.interface";
import { gcToInr } from "../../utils/helper.util";

const GroupClassTransaction = () => {
  const [gcTransactionList, setGcTransactionList] = useState<
    GroupClassPaymentInterface[]
  >([]);
  const [filteredGcTransactionList, setFilteredGcTransactionList] = useState<
    GroupClassPaymentInterface[]
  >([]);
  const dispatch: DispatchType = useDispatch();
  const [searchQuery, setSearchQuery] = useState<string>("");
  const { info } = useSelector((state: RootState) => state.info);
  console.log(info);
  useEffect(() => {
    if (!info) {
      dispatch(startLoading());
      dispatch(getInfo()).finally(() => {
        dispatch(stopLoading());
      });
    }

    //eslint-disable-next-line
  }, [info]);

  useEffect(() => {
    get(`/admin/group-class/get-transactions`).then((res) => {
      setGcTransactionList(res);
      setFilteredGcTransactionList(res);
    });
  }, []);

  const handleSearch = (query: string) => {
    setSearchQuery(query);
    const lowerQuery = query.toLowerCase();
    const filteredList = gcTransactionList?.filter((transaction) => {
      const teacherName = transaction.teacherId?.name?.toLowerCase() || "";
      return (
        transaction?.teacherId._id?.toLowerCase().includes(lowerQuery) ||
        transaction?.teacherId.name?.toLowerCase().includes(lowerQuery) ||
        transaction?.teacherId.email?.toLowerCase().includes(lowerQuery) ||
        teacherName.includes(lowerQuery)
      );
    });

    setFilteredGcTransactionList(filteredList);
  };

  const columns: Column[] = [
    { select: "_id", header: "Transaction ID", align: "left" },
    {
      header: "Amount (INR)",
      render: (_value: any, row: GroupClassPaymentInterface) => {
        return (
          <div>
            {row.currency === "Guru coin" ? (
              <div>{gcToInr(row.amount, info.conversionRate)}</div>
            ) : (
              <div>{row.amount}</div>
            )}
          </div>
        );
      },
    },
    {
      select: "currency",
      header: "Currency",
    },
    {
      header: "Status",
      render: (_value: any, row: GroupClassPaymentInterface) => {
        return (
          <div>
            {row?.status === "Pending" ? (
              <span className="text-orange-500">{row.status}</span>
            ) : (
              <span className="text-green-500">{row.status}</span>
            )}
          </div>
        );
      },
    },
    {
      select: "subsciptionType",
      header: "Subsciption Type",
    },
    {
      header: "Date & Time",
      render: (_value: any, row: GroupClassPaymentInterface) =>
        formatDateTime(row?.createdAt),
    },
    // {
    //   select: "status",
    //   header: "Status",
    //   align: "center",
    //   render: (value: string) => (
    //     <span
    //       className={`status-badge ${
    //         value === "Completed"
    //           ? "bg-green-500"
    //           : value === "Pending"
    //           ? "bg-yellow-500"
    //           : "bg-red-500"
    //       } text-white px-2 py-1 rounded`}
    //     >
    //       {value}
    //     </span>
    //   ),
    // },
    {
      header: "Teacher Name",
      render: (_value: any, row: GroupClassPaymentInterface) =>
        row?.teacherId?.name || "N/A",
    },
  ];

  return (
    <div className="gcTransaction table-container">
      <div className="title">Guru Coin Transactions</div>
      <div className="search-container mb-4">
        <input
          type="text"
          className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-gray-700"
          placeholder="Search transactions"
          value={searchQuery}
          onChange={(e) => handleSearch(e.target.value)}
        />
      </div>

      <TableComponent columns={columns} data={filteredGcTransactionList} />
    </div>
  );
};

export default GroupClassTransaction;
